<div *ngIf="!hideDistributionGraph">
	<div class="lift-histogram-area">
		<div class="header-area">
			Lift Distribution
			<span class="subtitle">Hover bars for detail</span>
		</div>
		<div class="graph-area">
			<div id="lift-histogram"></div>
		</div>
		<div class="footer-area">
			<div class="zips">
				Postal Codes: <span *ngIf="liftObj.regions">{{ liftObj.regions.length }}</span>
			</div>
			<div class="lift">
				Lift Range: <span *ngIf="liftObj.lift">{{ liftObj.lift }}</span>
			</div>
			<div class="clear"></div>
		</div>
	</div>
</div>
